export const STATUS = Object.freeze({
  SUCCESS: 'success',
  FAILURE: 'failure',
});

export const CASUAL_USER_ALLOW_EXPORT = '73';
